import { render, staticRenderFns } from "./BarGraphItem.vue?vue&type=template&id=08cec590&"
import script from "./BarGraphItem.vue?vue&type=script&lang=js&"
export * from "./BarGraphItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports